module.exports = __webpack_public_path__ + "7f7cf8a66d8c99e73f5d805efdbbf2fb.png";